/**
 * ADD RSS FEED - RISK ANGLES LEVELS TEMPLATE
 *
 *
 * @version 0.1
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';

import reduxStore from './../../../../reduxStore';
import utils from './../../../../utils/utilities';

import PestleHelp from '../../../../reusable/PestleHelp/PestleHelp';

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import actions from './../BaseFeedEditingComponent.actions.js';

/**
 * Slider Row Component
 *
 * Renders a singular slider along with its label.
 */

export class SliderRow extends React.Component {

    constructor(props) {
        super(props);

        this.state = {value: this.props.value || this.props.defaultValue};

        this.changeValue = this.changeValue.bind(this);
        this.getValue = this.getValue.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        /* If it's a controlled slider (has the "onChange" and "value" props),
         * then update it's value when the value prop changes.
         */
        if (nextProps.value !== this.state.value) {
            this.changeValue(nextProps.value);
        }

    }

    changeValue(value) {
        let thisComponent = ReactDOM.findDOMNode(this),
            slider        = thisComponent.querySelectorAll('.rc-slider-handle')[0];

        this.setState({value: value});

        if (value === this.props.min) {
            slider.classList.add('first-value');
        } else {
            slider.classList.remove('first-value');
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.onChangeData);
        }
    }

    getValue() {
        return this.state.value;
    }

    render() {

        return (
            <div className="slider-row">

                {this.props.label ?
                    <div className="slider-label">
                        <FormattedMessage id={this.props.label} />
                    </div> : null
                }

                <Slider dots={this.props.dots ? true : false}
                        value={this.state.value}
                        defaultValue={this.props.defaultValue}
                        min={this.props.min}
                        max={this.props.max}
                        onChange={this.changeValue} />
            </div>
        );

    }

}


/**
 * Risk Angles Levels Component
 *
 * Renders the PESTLE levels sliders for the user to choose one.
 */

class RiskAnglesLevels extends React.Component {

    constructor(props) {
        super(props);

        this.state = Object.assign(
            {
                selectedRiskAnglesOption: 'all-angles'
            },
            {
                riskAngles: reduxStore.getState().addRssFeed.riskAngles
            }
        );

        // In case the risk angles are loaded from the server, this flag takes care they are loaded only once.
        this.riskAnglesSettingsLoaded = false;

        this.sliderConfig = {
            min: 0,
            max: 3
        };

        // This array is used to iterate over the risk angles object in "PESTLE order".
        this.riskAngleKeysOrder = [
            'political',
            'economic',
            'social',
            'technological',
            'legal',
            'environmental'
        ];

        this.defaultRiskAngleLevels = {
            political:     this.sliderConfig.max,
            economic:      this.sliderConfig.max,
            social:        this.sliderConfig.max,
            technological: this.sliderConfig.max,
            legal:         this.sliderConfig.max,
            environmental: this.sliderConfig.max
        };

        this.resetSliders = this.resetSliders.bind(this);
        this.onSliderChange = this.onSliderChange.bind(this);
        this.isPaneVisible = this.isPaneVisible.bind(this);
        this.selectRiskAnglesSetting = this.selectRiskAnglesSetting.bind(this);

    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.riskAngles != null &&
            !this.riskAnglesSettingsLoaded &&
            !utils.isDeepEqual(nextState.riskAngles, this.defaultRiskAngleLevels)) {

            this.selectRiskAnglesSetting(null, 'custom-settings');
            this.riskAnglesSettingsLoaded = true;

        }
    }

    componentWillMount() {
        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState({
                    riskAngles: reduxStore.getState().addRssFeed.riskAngles
                });
            }
        );
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    onSliderChange(value, riskAngleKey) {
        actions.clearValidationErrors(['api.error.feed.noPestle']);

        let changedRiskAngle = {};
        changedRiskAngle[riskAngleKey] = value;

        actions.changeRiskAngles(
            Object.assign(
                {},
                this.state.riskAngles,
                changedRiskAngle
            )
        );
    }

    resetSliders() {
        actions.changeRiskAngles(Object.assign({}, this.defaultRiskAngleLevels));
    }

    selectRiskAnglesSetting(event, specificPane) {
        let value = specificPane || event.target.value;

        if (this.state.selectedRiskAnglesOption !== value) {
            actions.clearValidationErrors(['api.error.feed.noPestle']);

            if (!specificPane) {
                this.resetSliders();
            }

            this.setState({selectedRiskAnglesOption: value});
        }
    }

    isPaneVisible(pane) {
        return this.state.selectedRiskAnglesOption === pane ? '' : ' hidden'
    }

    render() {

        let sliderRows = [],
            riskAngles = this.state.riskAngles;

        for (let i = 0; i < this.riskAngleKeysOrder.length; i++) {
            let riskAngleName = this.riskAngleKeysOrder[i];

            sliderRows.push(
                <SliderRow dots
                           key={riskAngleName + '-risk-angle-level-slider'}
                           ref={riskAngleName + 'Slider'}
                           label={'RSS_Add_UIText_addRssFeed.riskAnglesLevels.' + riskAngleName}
                           value={riskAngles[riskAngleName]}
                           onChange={this.onSliderChange}
                           onChangeData={riskAngleName}
                           min={this.sliderConfig.min}
                           max={this.sliderConfig.max} />
            );
        }

        return (

            <div className="rss-section__risk-angles-levels">

                <h2 className="risk-angels-levels-title">
                    <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.title" />
                </h2>

                <p className="rss-section__risk-angles-levels__settings">
                    <span className="settings-option">
                        <input id="risk-angles-settings-all"
                               type="radio"
                               name="risk-angles-settings"
                               value="all-angles"
                               checked={this.state.selectedRiskAnglesOption === 'all-angles'}
                               onChange={this.selectRiskAnglesSetting} />
                        <label htmlFor="risk-angles-settings-all">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.selectAll" />
                        </label>
                    </span>
                    <span className="settings-option">
                        <input id="risk-angles-settings-custom"
                               type="radio"
                               name="risk-angles-settings"
                               value="custom-settings"
                               checked={this.state.selectedRiskAnglesOption === 'custom-settings'}
                               onChange={this.selectRiskAnglesSetting} />
                        <label htmlFor="risk-angles-settings-custom">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.customSettings" />
                        </label>
                    </span>
                </p>

                <p className={'rss-section__risk-angles-levels__all-levels' + this.isPaneVisible('all-angles')}>
                    <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.allResultsIncluded" />
                </p>

                <div className={'rss-section__risk-angles-levels__sliders' + this.isPaneVisible('custom-settings')}>

                    <div className="rss-section__risk-angles-levels__select-risk-level">
                        <p className="rss-section__risk-angles-levels__select-risk-level--paragraph">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.selectRiskLevel" />:
                            <PestleHelp position={'right'}/>
                        </p>

                    </div>

                    <p className={'add-rss-error add-rss-errors__risk-angles ' +
                                    this.props.setErrorClass(['api.error.feed.noPestle'])}>
                        <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.atLeastOneRiskLevelError" />
                    </p>

                    <div className="rss-section__risk-angles-levels__labels">
                        <span className="risk-angle-label">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.dontInclude" />
                        </span>
                        <span className="risk-angle-label">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.highOnly" />
                        </span>
                        <span className="risk-angle-label">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.highMedium" />
                        </span>
                        <span className="risk-angle-label">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.showAll" />
                        </span>
                    </div>

                    {sliderRows}

                </div>

            </div>

        );

    }

}

export default RiskAnglesLevels;


// WEBPACK FOOTER //
// ./src/scripts/pages/RSSEditing/BaseFeedEditingComponent/template/BaseFeedEditingComponent.riskAnglesLevels.jsx